/* eslint-disable no-unused-vars */
import Marquee from "react-fast-marquee";
import "../CSS/final.css";
import Helptag365 from "../Images/Company/Help.jpeg";
import Atithi from "../Images/Company/Atithi.png";
import Elphanso from "../Images/Company/Elphanso.png";
import Kwix from "../Images/Company/Kwix.png";
import Machine from "../Images/Company/Machine.jpeg";
import SS from "../Images/Company/SS.png";
import Rewa from "../Images/Company/Rewa.png";
import BioCraft from "../Images/Company/BioCraft.png";
import Bitafab from "../Images/Company/Bitafab.png";
import CC from "../Images/Company/CC.jpg";
import Dalment from "../Images/Company/Dalment.png";
import Deltin from "../Images/Company/Deltin.png";
import Glowing from "../Images/Company/Glowing.png";
import Gracy from "../Images/Company/Gracy.png";
import HariOm from "../Images/Company/HariOm.png";
import Kalateet from "../Images/Company/Kalateet.png";
import Kanha from "../Images/Company/Kanha.png";
import KUKU from "../Images/Company/KUKU.png";
import Motel from "../Images/Company/Motel.png";
import MS from "../Images/Company/MS.png";
import Raha from "../Images/Company/Raha.png";
import Solvi from "../Images/Company/Solvi.png";
import Zulaz from "../Images/Company/Zulaz.png";
import { useInView } from "react-intersection-observer";
// Import different logos

const logos = [Helptag365,Atithi,Elphanso,Kwix,Machine,SS,Rewa,BioCraft,Bitafab,CC,Dalment,Deltin,Glowing,Gracy,HariOm,Kalateet,Kanha,KUKU,Motel,MS,Raha,Solvi,Zulaz];
const LogoSlider = () => {
   const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.2 });
    return (
      <>
      <div className="flex items-center justify-center mt-10 mb-5">
        <button className="bg-[#432DD7] text-white font-[Nunito] text-[12px] md:text-[16px] w-[180px] md:w-[229px] h-[45px] md:h-[60px] rounded-full font-medium">Successfully Delivered</button>
      </div>
      <div className="App">
        
        {/* Marquee Container with Fade Effect */}
        <div className="marquee-container w-[50px]">
          <Marquee play direction="left" speed={75} delay={1}>
            {logos.map((logo, index) => (
              <div key={index} className="image_wrapper">
                <img src={logo} alt={`logo-${index}`} />
              </div>
            ))}
            {logos.map((logo, index) => (
              <div key={index} className="image_wrapper">
                <img src={logo} alt={`logo-${index}`} />
              </div>
            ))}
          </Marquee>
        </div>
      </div></>
    );
  };
  
  export default LogoSlider;
  